<ng-container *ngIf="(uxInteractions$ | async) as uxInteractions" [formGroup]="fUser">
  <!--  <ng-container *ngIf="(currentUser$ | async) as currentUser">-->


  <div appFlex appFlexLayout class="">
    <div appFlex class="info-box p-8">
      Last logged: {{currentUser.lastLogged | date: 'short'}}
    </div>
    <div appFlex class="info-box p-8 m-4">
      Created: {{currentUser.created | date: 'short'}}
    </div>
  </div>

  <div *ngIf="currentUser.type === 'client'" appFlex class="p-8 mt-8">
    <app-url-placeholder [url]="getLoginUrl()"></app-url-placeholder>
  </div>

  <div appFlex appFlexLayout *ngIf="currentUser.type === 'client'" class="p-8 mt-16">

    <ng-container *ngIf="(organizationList$ | async) as organizationList">

      <dx-select-box
        class="w-100-p"
        [dataSource]="organizationList"

        displayExpr="name"
        valueExpr="id"

        [searchMode]="'contains'"
        [searchExpr]="['id', 'name']"
        [searchTimeout]="200"
        [minSearchLength]="0"
        [searchEnabled]="true"

        formControlName="organizationId"

      >
      </dx-select-box>

    </ng-container>

  </div>


  <div appFlex appFlexLayout>
    <mat-form-field appFlex class="h-100-p p-8">
      <mat-label>Firstname</mat-label>
      <input matInput type="text" formControlName="firstname">
    </mat-form-field>
    <mat-form-field appFlex class="h-100-p p-8">
      <mat-label>Lastname</mat-label>
      <input matInput type="text" formControlName="lastname">
    </mat-form-field>
  </div>

  <div appFlex appFlexLayout>
    <mat-form-field appFlex class="h-100-p p-8">
      <mat-label>Email</mat-label>
      <input matInput type="text" formControlName="email">
    </mat-form-field>
  </div>

  <div appFlex appFlexLayout class="mat-elevation-z2">
    <mat-form-field appFlex class="h-100-p p-8">
      <mat-label>Change password</mat-label>
      <input matInput type="text" formControlName="newPassword">
    </mat-form-field>
  </div>

  <app-user-client-roles-selector
    *ngIf="currentUser.type === 'client'"
    class="mt-4"
    style="max-height: 350px;"
    [formControl]="fUser.get('userAccess')"
  >
  </app-user-client-roles-selector>

  <div
    appFlex appFlexLayout appFlexAlign="end center" class="mt-8">

    <button
      mat-stroked-button class="mr-4 warn"
      [ladda]="disablingUser$|async"
      (click)="disableUser()"
    >Disable
    </button>

    <button
      [disabled]="fUser.pristine || !fUser.valid"
      mat-raised-button class="primary"
      [ladda]="updatingUser$|async"
      (click)="updateUser()"
    >Update
    </button>
  </div>

  <div *appIfDebugMode>
    <pre>{{fUser.getRawValue()|json}}</pre>
  </div>

  <span appFlex="grow"></span>


  <!--  </ng-container>-->
</ng-container>
